import NotFooterLayout from "layouts/NotFooterLayout";
import ManageParcel from "components/ManageParcel";

function ManageParcelPage() {
  return (
    <NotFooterLayout namePage="ส่งพัสดุทั่วไป" >
      <div className="layout-content">
        <ManageParcel />
      </div>
    </NotFooterLayout>
  );
}

export default ManageParcelPage;
